import React, { useCallback, useState } from 'react';
import css from './FilterSidebar.module.css';
import {
  BrandOfferingFilterCategories,
  filterBrandSidebarSectionLabels,
  PARAM_KEYS,
  UserType,
} from '../../../util/enums';
import { FormattedMessage } from 'react-intl';
import IndustryFilterSection from './IndustryFilterSection';
import { getSelectedValues } from '../../../util/genericHelpers';
import BrandPremierFilterSection from './BrandPremierFilterSection';
import { createResourceLocatorString } from '../../../util/routes';
import { jobCategories } from '../../../config/configSearch';
import StateFilterSection from './StateFilterSection';
import SearchBar from '../SearchBar';
import { BRAND, OPPORTUNITIES } from '../../../util/constants';

const BrandFilterSidebar = ({
  resetAllFilters,
  handleCheckboxChange,
  handleClearFilter,
  updateMultipleURLParams,
  history,
  routeConfiguration,
  location,
  updateURLParams,
  userType,
  onHandleSearchChange,
  intl,
  associatedListingCategory,
  activeCategory,
}) => {
  // Track which main sections are active
  const [activeSections, setActiveSections] = useState({
    industry: false,
    location: false,
    brandPremier: false,
    brandStandard: false,
    opportunities: false,
  });

  // Toggle main sections
  const toggleSection = useCallback(
    key => {
      setActiveSections(prev => {
        const nextActive = !prev[key];
        const updatedSections = { ...prev, [key]: nextActive };

        // Update URL
        if (nextActive) {
          const currentSubscriptions = Object.keys(updatedSections)
            .filter(k => ['brandPremier', 'brandStandard'].includes(k) && updatedSections[k])
            .map(k => filterBrandSidebarSectionLabels[k]);
          updateMultipleURLParams({
            [PARAM_KEYS.subscriptionType]: currentSubscriptions.length ? currentSubscriptions : [],
            [PARAM_KEYS.ListingCategory]: ['brand'], // Add pub_listingCategory=brand
          });
        } else {
          const remainingSubscriptions = Object.keys(updatedSections)
            .filter(k => ['brandPremier', 'brandStandard'].includes(k) && updatedSections[k])
            .map(k => filterBrandSidebarSectionLabels[k]);
          if (remainingSubscriptions.length === 0) {
            handleClearFilter(PARAM_KEYS.subscriptionType);
          } else {
            updateMultipleURLParams({
              [PARAM_KEYS.subscriptionType]: remainingSubscriptions,
              [PARAM_KEYS.ListingCategory]: ['brand'],
            });
          }
        }

        if (key === OPPORTUNITIES) {
          history.push(
            createResourceLocatorString(
              'BrandOfferingPage',
              routeConfiguration,
              {},
              {
                pub_listingCategory: BRAND,
                jobCategoryFilter: BrandOfferingFilterCategories.CAMPAIGNS,
              }
            )
          );
        }

        return updatedSections;
      });
    },
    [updateURLParams, handleClearFilter]
  );

  const selectedIndustry = getSelectedValues(PARAM_KEYS.primaryIndustry, location);
  const selectedSubscriptionType = getSelectedValues(PARAM_KEYS.subscriptionType, location);
  const selectedState = getSelectedValues(PARAM_KEYS.state, location);

  // When clicking a job category, update the URL parameter "pub_listingCategory"
  const handleJobCategoryClick = jobCategoryKey => {
    // history.push(
    //   createResourceLocatorString(
    //     'BrandOfferingPage',
    //     routeConfiguration,
    //     {},
    //     { pub_listingCategory: 'brand', jobCategoryFilter: jobCategoryKey }
    //   )
    // );
  };

  const resetAll = () => {
    resetAllFilters();
    setActiveSections({
      industry: false,
      location: false,
      brandPremier: false,
      brandStandard: false,
      opportunities: false,
    });
  };

  return (
    <div className={css.filterSidebar}>
      {/* <div className={css.filterHeader}>
        <h2 className={css.title}>
          <FormattedMessage id="FilterCategories.filters" />
        </h2>
        <button className={css.resetAllButton} onClick={resetAll}>
          <FormattedMessage id="FilterCategories.resetAll" />
        </button>
      </div> */}

      {/* Search Bar */}
      <SearchBar
        onSearch={onHandleSearchChange}
        placeholder={intl.formatMessage({ id: 'FilterCategories.BrandFilterSidebar.search' })}
        activeCategory={activeCategory}
        hideCategories
      />
      {/* Pill Container (main sections) */}

      <div className={css.pillContainer}>
        {Object.keys(filterBrandSidebarSectionLabels).map(key => {
          // Only include 'opportunities' when associatedListingCategory is 'brand'
          // if (key === OPPORTUNITIES && associatedListingCategory !== BRAND) {
          //   return null;
          // }
          return (
            <button
              key={key}
              className={`${css.pill} ${activeSections[key] ? css.activePill : ''}`}
              onClick={() => toggleSection(key)}
              aria-pressed={activeSections[key]}
            >
              {filterBrandSidebarSectionLabels[key]}
            </button>
          );
        })}
      </div>
      {/* Industry Section */}
      {activeSections.industry && (
        <IndustryFilterSection
          selectedValues={selectedIndustry}
          paramKey={PARAM_KEYS.primaryIndustry}
          handleCheckboxChange={handleCheckboxChange}
          handleClearFilter={handleClearFilter}
        />
      )}

      {/* Location Section */}
      {activeSections.location && (
        <div className={css.subSection}>
          <StateFilterSection
            handleCheckboxChange={handleCheckboxChange}
            handleClearFilter={handleClearFilter}
            selectedValues={selectedState}
            paramKey={PARAM_KEYS.state}
          />
        </div>
      )}

      {/* Jobs Section */}
      {activeSections.opportunities && userType === UserType.TALENT && (
        <div className={css.jobsSection}>
          <h3 className={css.jobsTitle}>
            <FormattedMessage id="FilterCategories.jobs" />
          </h3>
          <div className={css.jobCategoriesContainer}>
            {jobCategories.map(job => (
              <button
                key={job.key}
                className={css.jobCategoryButton}
                onClick={() => handleJobCategoryClick(job.key)}
              >
                {job.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default BrandFilterSidebar;
